import { Button, Checkbox, Form, Input, Space, message } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@core/server";

const errMsg = (e) => e?.message || "Ошибка";

const defaultItem = { active: true, name: "", code: "", url: "" };

const AgentForm = ({ id, onClose }) => {
  const [item, setItem] = useState(defaultItem);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (id) {
      setLoading(true);
      serverFetch(`Agent/${id}`)
        .then((data) => {
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch((e) => message.error(errMsg(e)))
        .finally(() => setLoading(false));
    } else {
      form.setFieldsValue(defaultItem);
      setItem(defaultItem);
    }
  }, [id, form]);

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  };

  const onSave = () => {
    form.validateFields().then(() => {
      setLoading(true);
      const payload = {
        ...item,
        name: item.name ?? "",
        code: item.code ?? "",
        url: item.url ?? "",
        active: item.active ?? true
      };
      if (id) payload.id = id;
      serverFetch("Agent", { method: id ? "PUT" : "POST", bodyData: payload })
        .then(() => onClose(true))
        .catch((e) => {
          setLoading(false);
          message.error(errMsg(e));
        });
    });
  };

  return (
    <Form
      form={form}
      onValuesChange={onValuesChange}
      labelCol={{ span: 7 }}
      wrapperCol={{ span: 17 }}
      colon={false}
      disabled={loading}
    >
      <Form.Item name="active" valuePropName="checked" label=" ">
        <Checkbox>Активный</Checkbox>
      </Form.Item>
      <Form.Item name="name" label="Наименование" rules={[{ required: true, message: "Введите наименование" }]}>
        <Input placeholder="Наименование агента" />
      </Form.Item>
      <Form.Item name="url" label="URL">
        <Input placeholder="https://agent.example.com" />
      </Form.Item>
      <Form.Item name="code" label="Код (токен)">
        <Input placeholder="Токен авторизации" />
      </Form.Item>
      <Form.Item label=" ">
        <Space style={{ width: "100%", justifyContent: "space-between" }}>
          <Button type="primary" onClick={onSave} loading={loading}>
            Сохранить
          </Button>
          <Button onClick={() => onClose(false)}>Закрыть</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default AgentForm;
